import $ from 'jquery';
import Swiper, { Navigation, Pagination } from 'swiper';

$(function() {

    Swiper.use([Navigation, Pagination]);

    if ($('.carousel-construction').length) {

        const swiperConstruction = new Swiper('.carousel-construction', {
            // Optional parameters
            loop: true,
            slidesPerView: 1,
            spaceBetween: 48,

            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
            },

            // Navigation arrows
            navigation: {
                nextEl: '.btn-construction__next',
                prevEl: '.btn-construction__prev',
            },

            breakpoints: {
                480: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 4,
                },
                1280: {
                    slidesPerView: 6,
                }
            }


        });

    }

    if ($('.carousel-partners').length) {



        let swiperPartners; // Declare swiperPartners outside the function to make it accessible globally

function disableSwiper() {
    if (window.innerWidth >= 1280) {
        if (swiperPartners && swiperPartners.destroy) {
            swiperPartners.destroy(true, true); // Destroy Swiper and leave the slides intact
        }
    } else {
        if (!swiperPartners || !swiperPartners.initialized) {
            // Create Swiper only if it's not defined or not initialized
            swiperPartners = new Swiper('.carousel-partners', {
                // Optional parameters
                loop: true,
                slidesPerView: 1,
                spaceBetween: 48,

                // If we need pagination
                pagination: {
                    el: '.swiper-pagination',
                },

                // Navigation arrows
                navigation: {
                    nextEl: '.btn-partners__next',
                    prevEl: '.btn-partners__prev',
                },

                breakpoints: {
                    480: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 4,
                    },
                    1280: {
                        slidesPerView: 6,
                    }
                }
            });
        }
    }
}

// Listen for window resize events
window.addEventListener('resize', disableSwiper);

// Call the function on initial load
disableSwiper();
    }

});
